import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState,
  reducers: {
    loading(state) {
      state.loading = true;
      state.error = null;
    },
    error(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setAboutUsList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { loading, error, setAboutUsList } = aboutUsSlice.actions;

export default aboutUsSlice.reducer;
